import React, { useState } from 'react';
import { InputText } from 'primereact/inputtext';
import { CustomExpander } from '../CustomExpander';
import { FilterCheckBoxItem } from './filter-check-box-item';

interface FilterExpanderWithListOfCheckboxesProps<
  T,
  K extends string | number = string,
> {
  title: string;
  items: T[];
  selectedItems: K[];
  onItemToggle: (item: K) => void;
  getItemLabel: (item: T) => string;
  getItemKey: (item: T) => K;
  defaultExpanded?: boolean;
  searchPlaceholder?: string;
}

const styles = {
  section: {
    padding: '4px 0',
  },
  search: {
    width: '100%',
    marginBottom: '12px',
    direction: 'rtl' as const,
    backgroundColor: '#f8f9fa',
    border: '1px solid #e9ecef',
    borderRadius: '6px',
    padding: '8px 12px',
    fontSize: '0.95rem',
    transition: 'all 0.2s ease',
    outline: 'none',
  },
  checkboxList: {
    maxHeight: '200px',
    overflowY: 'auto' as const,
    borderRadius: '6px',
    padding: '4px',
    backgroundColor: '#f8f9fa',
    border: '1px solid #e9ecef',
  },
};

export function FilterExpanderWithListOfCheckboxes<
  T,
  K extends string | number = string,
>({
  title,
  items,
  selectedItems,
  onItemToggle,
  getItemLabel,
  getItemKey,
  defaultExpanded = false,
  searchPlaceholder = 'חפש...',
}: FilterExpanderWithListOfCheckboxesProps<T, K>) {
  const [searchText, setSearchText] = useState('');

  const filteredItems = items.filter((item) =>
    getItemLabel(item).toLowerCase().includes(searchText.toLowerCase()),
  );

  return (
    <CustomExpander
      badge={selectedItems.length}
      defaultExpanded={defaultExpanded}
    >
      <div>{title}</div>
      <div style={styles.section}>
        <InputText
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          placeholder={searchPlaceholder}
          style={styles.search}
        />
        <div style={styles.checkboxList}>
          {filteredItems.map((item) => (
            <FilterCheckBoxItem
              key={getItemKey(item).toString()}
              label={getItemLabel(item)}
              isChecked={selectedItems.includes(getItemKey(item))}
              onChange={() => onItemToggle(getItemKey(item))}
            />
          ))}
        </div>
      </div>
    </CustomExpander>
  );
}
